import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-select-or-add',
  templateUrl: './select-or-add.component.html',
  styleUrl: './select-or-add.component.scss'
})
export class SelectOrAddComponent {
  @Input({ required: true }) bindLabel!: string;
  @Input({ required: true }) bindValue!: string;
  @Input({ required: true }) placeholder!: string;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) errorMessage!: string;

  @Input({ required: true }) control!: FormControl;

  @Input({ required: true }) fetchFn!: (pageNumber: number, pageSize: number, term: string)
    => Observable<any[]>;
  @Input({ required: true }) fetchSelectedItem!: (id: any) => Observable<any>;

  @Input({ required: false }) width = "30%";
  @Input({ required: false }) id?: string;
  @Input({ required: false }) writeValue = true;

  @Input({ required: false }) isResponsive = true;

  @Input() refresh = 0;

  @Output() add = new EventEmitter<void>();

  @Output() itemSelected = new EventEmitter<any>();
  @Input({ required: false }) clearAfterSelection = false;

  @Input() disabled = false;

  /** When false, the add button is hidden (e.g. when user has no create permission). Default true. */
  @Input() showAddButton = true;

  isInvalid(): boolean {
    const control = this.control;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }
}
